import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useInfiniteQuery } from '@tanstack/react-query';
import { RelocationsApiAdapter } from '../adapters/RelocationsApiAdapter';
import { RelocationListFilters } from '../models/Relocation';
import { Service } from '../services/Service';

export const useRelocations = (filters: RelocationListFilters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new RelocationsApiAdapter(httpClient);
  const service = new Service(apiAdapter);

  const { data, isLoading, isFetching, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage, isPending } =
    useInfiniteQuery({
      queryKey: ['relocations', filters],
      queryFn: ({ pageParam = 1 }) =>
        service.getPaginated({
          ...filters,
          page: pageParam,
        }),
      getNextPageParam: (lastPage) => lastPage.nextPage,
      initialPageParam: 1,
      staleTime: 2 * 60 * 1000,
      placeholderData: (previousData) => previousData,
    });

  const relocations = data?.pages.flatMap((page) => page.relocations) ?? [];
  const totalFromApi = data?.pages?.[0]?.total ?? 0;

  return {
    relocations,
    isLoading: isLoading || isPending,
    isFetching,
    error,
    refetch,
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
    total: totalFromApi,
  };
};
